import { render, staticRenderFns } from "./IpDxGf.vue?vue&type=template&id=004368ee&scoped=true&"
import script from "./IpDxGf.vue?vue&type=script&lang=js&"
export * from "./IpDxGf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004368ee",
  null
  
)

export default component.exports